<template>
  <e-modal-custom-form
    ref="modalCancelForm"
    title="Cancelamento da requisição de compra"
    @after-confirm="$emit('after-confirm')"
  >
    <b-row>
      <b-col
        md="12"
        class="d-flex flex-column"
      >
        <FormulateInput
          id="cancel_modal-reason"
          v-model="cancelForm.reason"
          name="reason"
          class="w-100 required"
          type="textarea"
          validation="required|min:15,length"
          rows="4"
          :label="$t('Motivo do cancelamento')"
        />
      </b-col>
    </b-row>
  </e-modal-custom-form>
</template>

<script>
import EModalCustomForm from '@/views/components/EModalCustomForm.vue'
import { BCol, BRow } from 'bootstrap-vue'
import { mapActions } from 'vuex'

const getDefaultCancelForm = () => ({
  reason: '',
})

export default {
  components: {
    BCol,
    BRow,
    EModalCustomForm,
  },

  props: {},
  data() {
    return {
      cancelForm: getDefaultCancelForm(),
    }
  },
  methods: {
    ...mapActions('pages/purchase/purchaseRequisition/purchaseRequisitionMaintain', {
      stCancelPurchaseRequisition: 'cancelPurchaseRequisition',
    }),

    resetModal() {
      this.cancelForm = getDefaultCancelForm()
    },

    async showModal(purchaseRequisition) {
      this.resetModal()

      if (!this.$can('Cancel', 'PurchaseRequisition')) {
        this.showWarning({ message: this.$t('without_permission') })
        return
      }

      if (
        await this.confirmHtml({
          title: '',
          html: `Confirma cancelamento da requisição de compra #${purchaseRequisition.id}? Esta ação não poderá ser revertida.`,
        })
      ) {
        this.$refs.modalCancelForm.show(async () => {
          try {
            await this.stCancelPurchaseRequisition({
              purchaseRequisitionId: purchaseRequisition.id,
              reason: this.cancelForm.reason,
            })

            this.showSuccess({ message: this.$t('Requisição de compra cancelada com sucesso.') })
          } catch (error) {
            this.showError(error)
          }
        })
      }
    },
  },
}
</script>
